import { useContext, useEffect, useState } from "react";
import { CartContext } from "../../store/context/CartContext";
import NotificationService from "../../services/notification.service";

const FALLBACK_CHANNELS = [
  { slug: "general", name: "General (Todas)" },
  { slug: "premium", name: "Premium (Membresía)" },
  { slug: "live", name: "Vivos" },
];

const useNotifications = () => {
  const { setTitleSeccion } = useContext(CartContext);
  const [channels, setChannels] = useState(FALLBACK_CHANNELS);
  const [selectedChannel, setSelectedChannel] = useState("general");
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [priority, setPriority] = useState("high");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    setTitleSeccion("Notificaciones");
    fetchChannels();
  }, []);

  const fetchChannels = async () => {
    try {
      const data = await NotificationService.getChannels();
      console.log("Fetched channels:", data);
      if (Array.isArray(data) && data.length > 0) {
        const ALLOWED_SLUGS = ["premium", "general"];
        setChannels(data.filter((ch) => ALLOWED_SLUGS.includes(ch.slug)));
      }
    } catch (err) {
      console.warn("Using fallback channels");
    }
  };

  const sendNotification = async () => {
    if (!title.trim() || !body.trim()) return;

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await NotificationService.sendToChannel({
        channelSlug: selectedChannel,
        title: title.trim(),
        body: body.trim(),
        priority,
      });

      setResult(response);
      setHistory((prev) => [
        {
          title: title.trim(),
          body: body.trim(),
          channel: selectedChannel,
          sentAt: new Date().toLocaleTimeString(),
          sent: response.sent,
        },
        ...prev,
      ]);
      setTitle("");
      setBody("");
    } catch (err) {
      setError("Error al enviar la notificación. Intentá de nuevo.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const canSend = title.trim().length > 0 && body.trim().length > 0 && !loading;

  return {
    channels,
    selectedChannel,
    setSelectedChannel,
    title,
    setTitle,
    body,
    setBody,
    priority,
    setPriority,
    loading,
    result,
    setResult,
    error,
    setError,
    history,
    sendNotification,
    canSend,
  };
};

export default useNotifications;
